<template>
    <v-layout row justify-center>
        <v-dialog v-model="settings.visible" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click="settings.visible = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{ $t("captainsPage.captainConfirmation") }}</v-toolbar-title>
                </v-toolbar>

                <v-stepper v-model="step">
                    <v-stepper-header>
                        <v-stepper-step :complete="step > 1" step="1">{{ $t("captainsPage.personalInfo") }}</v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step :complete="step > 2" step="2">{{ $t("captainsPage.carInfo") }}</v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step :complete="step > 3" step="3">{{ $t("captainsPage.contract") }}</v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step step="4">{{ $t("captainsPage.finish") }}</v-stepper-step>
                    </v-stepper-header>

                    <v-stepper-items>
                        <v-stepper-content step="1">
                            <personal-info ref="personal_info" @done="loading = false" @next_step="next()"></personal-info>
                        </v-stepper-content>
                        <v-stepper-content step="2">
                            <car-info ref="car_info" @done="loading = false" @next_step="next()"></car-info>
                        </v-stepper-content>
                        <v-stepper-content step="3">
                            <contract-info ref="contract_info" @done="loading = false" @next_step="next()"></contract-info>
                        </v-stepper-content>
                        <v-stepper-content step="4">
                            <summary-info ref="summary_info" @done="loading = false" @next_step="next()" provider="captain" :id="settings.captain_id"></summary-info>
                        </v-stepper-content>
                        <p class="text-xs-end">
                            <v-btn :disabled="step === 1" @click="step--">{{ $t("captainsPage.previousStep") }}</v-btn>
                            <v-btn :disabled="loading" :color="step === 4 ? 'primary' : ''" @click="submit">{{step < 4 ? $t("captainsPage.approveAndSave") :
                                $t("captainsPage.approveCaptain")}}
                            </v-btn>
                        </p>
                    </v-stepper-items>
                </v-stepper>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    import LoadingComponent from "@/components/LoadingComponent";
    import PersonalInfo from "@/components/confirmation_captain_components/PersonalInfo";
    import CarInfo from "@/components/confirmation_captain_components/CarInfo";
    import ContractInfo from "@/components/confirmation_captain_components/ContractInfo";
    import SummaryInfo from "@/components/confirmation_captain_components/SummaryInfo";

    export default {
        components: {SummaryInfo, ContractInfo, CarInfo, PersonalInfo, LoadingComponent},
        props: {
            settings: {
                type: Object,
                default: () => ({
                    visible: false,
                    captain_id: null
                })
            }
        },
        watch: {
            settings: {
                handler(val) {
                    if(val.visible) {
                        this.step = 1;
                        this.init(this.step);
                    }
                },
                deep: true
            }
        },
        data() {
            return {
                step: 1,
                loading: false,
                ref_map: {
                    1: 'personal_info',
                    2: 'car_info',
                    3: 'contract_info',
                    4: 'summary_info'
                }
            }
        },
        methods: {
            init(cnt) {
                this.$refs[this.ref_map[cnt]].reset();
                this.$refs[this.ref_map[cnt]].update(this.settings.captain_id);
            },
            submit() {
                this.loading = true;
                this.$refs[this.ref_map[this.step]].submit();
            },
            next() {
                if(this.step < 4) {
                    this.init(this.step + 1);
                } else {
                    this.settings.visible = false;
                    this.$emit('approved', this.settings.captain_id);
                }
                (this.step + 1) > 4 ? this.step = 1 : this.step++;
            }
        }
    }
</script>